import styled from 'styled-components';

const StyledVideo = styled.video`
  margin-bottom: 10px;
  max-width: 100%;
  max-height: 100%;
  height: auto;
`;

export {
  StyledVideo,
};
